import { Injectable } from '@angular/core';
import { HttpService } from '../http-service';

/**
 * Provider para gerenciamento de menus dinâmicos
 * Compatível com sistema de controle de acesso do backend
 */
@Injectable()
export class MenuProvider {

  constructor(
    private http: HttpService
  ) {}

  /**
   * Busca menus do usuário autenticado baseado em seu perfil
   * @returns Promise<any>
   */
  getMenus(): Promise<any> {
    return this.http.get('/menus/mobile')
      .toPromise()
      .then(function(response) {
        var data = response.json();
        if (data && data.data) {
          return data;
        }
        throw new Error('Resposta inválida do servidor');
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/menu/menu.provider.ts